var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8423 3.97453C23.8423 1.86516 22.2907 0.168281 20.3735 0.168281C17.7767 0.0468748 15.1282 0 12.4217 0H11.5779C8.87792 0 6.2248 0.0468749 3.62792 0.16875C1.71542 0.16875 0.163859 1.875 0.163859 3.98437C0.0466718 5.65266 -0.00301573 7.32141 -0.000203231 8.99016C-0.00489073 10.6589 0.0482343 12.3292 0.159172 14.0011C0.159172 16.1105 1.71073 17.8214 3.62323 17.8214C6.35136 17.948 9.1498 18.0042 11.9951 17.9995C14.8451 18.0089 17.6357 17.9495 20.367 17.8214C22.2842 17.8214 23.8357 16.1105 23.8357 14.0011C23.9482 12.3277 23.9998 10.6589 23.9951 8.98547C24.0057 7.31672 23.9548 5.64641 23.8423 3.97453ZM9.70292 13.5886V4.37766L16.4998 8.98078L9.70292 13.5886Z",
    fill: "#1D1D1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector (2).63ee139e07ba5a01a75d7e846a0fd946.svg";
export { ForwardRef as ReactComponent };